export default __webpack_public_path__ + "static/media/7.0afc5626.jpg";